import { SeverityLevelContact } from './severity-level-contacts';

export const NOC_SEVERITY_LEVEL_CONTACTS: SeverityLevelContact[] = [
  {
    severity: '1st Level',
    contacts: [
      {
        name: 'NOC Assigned Technician',
        phones: [{ number: '+1 866 892 0915', type: 'OFF' }],
        email: 'CBNnoc@comcast.com',
      },
    ],
  },
  {
    severity: '2nd Level',
    link: '2nd-level',
    generalEmail: 'CBNnoc.managers@comcast.com',
    contacts: [
      {
        name: 'Doug Kozak',
        title: 'NOC Manager',
        phones: [{ number: '+1 773 364 3180', type: 'OFF' }],
      },
      {
        name: 'Fabricio Jimenez',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 215 5848', type: 'OFF' }],
      },
      {
        name: 'Laura Monge',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 702 5027', type: 'OFF' }],
      },
      {
        name: 'Andres Camacho',
        title: 'NOC Manager',
        phones: [{ number: '+1 773 770 1372', type: 'OFF' }],
      },
      {
        name: 'Oscar Chavez',
        title: 'NOC Manager',
        phones: [{ number: '+1 872 702 5028', type: 'OFF' }],
      },
    ],
  },
  {
    severity: '3rd Level',
    link: '3rd-level',
    contacts: [
      {
        name: 'Javier Chacon',
        title: 'Sr. Manager, NOC',
        phones: [
          { number: '+1 773 364 3175', type: 'OFF' },
          { number: '+506 7011 7876', type: 'CEL' },
        ],
        email: 'Javier_ChaconMonge@comcast.com',
      },
      {
        name: 'Phil Lukacek',
        title: 'Sr. Manager, NOC',
        phones: [
          { number: '+1 312 924 7729', type: 'OFF' },
          { number: '+1 708 219 0366', type: 'CEL' },
        ],
        email: 'Phillip_Lukacek@comcast.com',
      },
    ],
  },
  {
    severity: '4th Level',
    link: '4th-level',
    contacts: [
      {
        name: 'Jason Wiley',
        title: 'Sr. Manager, Escalations Management',
        phones: [
          { number: '+1 312 253 4368', type: 'OFF' },
          { number: '+1 312 656 3481', type: 'CEL' },
        ],
        email: 'Jason_Wiley@comcast.com',
      },
    ],
  },
  {
    severity: '5th Level',
    link: '5th-level',
    contacts: [
      {
        name: 'Mauricio Lizano',
        title: 'VP of NOC',
        phones: [
          { number: '+1 214 275 9246', type: 'OFF' },
          { number: '+506 8821 6575', type: 'CEL' },
        ],
        email: 'Mauricio_LizanoSaborio@comcast.com',
      },
    ],
  },
  {
    severity: '6th Level',
    contacts: [
      {
        name: 'Lawrence Edmond',
        title: 'VP of Engineering',
        phones: [
          { number: '+1 773 364 3189', type: 'OFF' },
          { number: '+1 219 798 6414', type: 'CEL' },
        ],
        email: 'Lawrence_Edmond@comcast.com',
      },
    ],
  },
  {
    severity: '7th Level',
    contacts: [
      {
        name: 'Chris Lawler',
        title: 'VP, Business Operations & Support',
        phones: [{ number: '+1 215 638 6524', type: 'OFF' }],
        email: 'chris_lawler@cable.comcast.com',
      },
    ],
  },
];
